import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap'
import moment from 'moment'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

let app = createApp(App)

app.config.globalProperties.$moment=moment;

app.use(store).use(router)

router.isReady().then(() => {
    app.component("v-select", vSelect).mount('#app')
})
